import { render, staticRenderFns } from "./swipers-button.vue?vue&type=template&id=6950edf4&scoped=true&"
import script from "./swipers-button.vue?vue&type=script&lang=js&"
export * from "./swipers-button.vue?vue&type=script&lang=js&"
import style0 from "./swipers-button.vue?vue&type=style&index=0&id=6950edf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950edf4",
  null
  
)

export default component.exports